import { Grid } from "@material-ui/core";
import { Text, SVG } from "sunrise-ui";
import "./Reports.scss";

const displayDate = (dateString: string) => {
    if (dateString) {
        const date = new Date(dateString);
        const month = date.toLocaleString("default", { month: "short" });
        const day = `0${date.getDate()}`.slice(-2);
        return `${day} ${month}, ${date.getFullYear()}`;
    }
    return "";
};

const displayDateAndTime = (dateString: string) => {
    if (dateString) {
        const date = new Date(dateString);
        const month = date.toLocaleString("default", { month: "short" });
        const day = `0${date.getDate()}`.slice(-2);
        let hours = date.getHours();
        const MM = `0${date.getMinutes()}`.slice(-2);
        const AMPM = hours >= 12 ? 'pm' : 'am';
        hours = hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const HH = `0${hours}`.slice(-2);
        return `${day} ${month}, ${date.getFullYear()}, ${HH}:${MM} ${AMPM}`;
    }
    return "";
};
const DrawerRow = (props: any) => {

    const { header, value, format } = props;

    const data = format ? value : format?.toLocaleLowerCase() === 'date' ? displayDate(value) : format?.toLocaleLowerCase() === 'datetime' ? displayDateAndTime(value) : value;

    return (
        <Grid item xs={12}>
            <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="mb mt0"
            >
                <span className="fw400">{header}</span>
                <span className="float-right">
                    {data}
                </span>
            </Text>
        </Grid>
    );
}
const PileDrawer = (props: any) => {
    const { drawerData, toggleDrawer } = props;
 
   const filteredResult = (drawerData !== "") ? (drawerData?.steps).find((e: any) => e?.status === "work in progress") : "";

    const pileDetailsData = [
        { header: 'Pile Work Started on', value: drawerData?.createdAt.split("T")[0], format: 'datetime' },
        { header: 'Steps in Progress', value:[filteredResult?.stepNumber," ", filteredResult?.stepName]},
        { header: 'Site Location', value: (drawerData?.pileLocation) ? drawerData?.pileLocation : "Nill" },
        { header: 'Natural Ground Level (NGL)', value: drawerData?.naturalGroundLevel},
        { header: 'Casing Top Level (CTL)', value: drawerData?.casingTopLevel },
        { header: 'Founding Level (FL)', value: drawerData?.foundingLevel},
        { header: 'Cut-Off Level (COL)', value: drawerData?.cutOffLevel},
        { header: 'Required BOre Depth (m)', value: drawerData?.boreDepth},
        { header: 'Hook Length (m)', value: drawerData?.hookLength},
        { header: 'Pile Cap Height (m)', value: drawerData?.pileCapHeight},
        { header: 'Pile Length Below COL (m)', value: drawerData?.pileLengthBelowCOL},
    ]

    const generatePileDetailFields = () => {
        return pileDetailsData.map((item: any, index: any) => <DrawerRow key={`drawer_pile_field${index}`} header={item?.header} value={item?.value} format={item?.format} />)
    }
    return (
      
        <Grid> 
            <div className="right_drawer_page">
                <Grid container className="drwaer_container p1">
                    <Grid item xs={11}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb1 mt0 capitalize"
                        >
                            {`Pile ${drawerData?.pileId} Details`}
                        </Text>
                    </Grid>
                    <Grid
                        item
                        xs={1}
                        className="pointer"
                        onClick={() => toggleDrawer(false)}
                    >
                        <SVG type={"close"} />
                    </Grid>
                    {/* -----------------------Operator detail---------- ------------*/}
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb1 mt0"
                        >
                            Pile Level Details
                        </Text>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        container
                        spacing={1}
                        className="right_drawer_details_container"
                    >
                        {generatePileDetailFields()}
                       
                    </Grid> 

                    {/* -----------------------Steel Diameter Details---------- ------------*/}
                    <Grid item xs={12}>
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb1 mt1"
                        >
                            Steel Diameter Level Details
                        </Text>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        container
                        spacing={1}
                        className="right_drawer_details_container"
                    >
                        {/* ----------8mm----------- */}
                        <Grid item xs={12}>
                            <Text
                                type="normal"
                                fonts="normal"
                                fontSize={14}
                                className="mb mt0"
                            >
                                <span className="fw400">8 mm</span>
                                <span className="float-right">
                                    {(drawerData?.reinforcement[0]?.type === 8) ? (drawerData?.reinforcement[0]?.count) : 0}
                                </span>
                            </Text>
                        </Grid>
                         {/* ----------10mm----------- */}
                         <Grid item xs={12}>
                            <Text
                                type="normal"
                                fonts="normal"
                                fontSize={14}
                                className="mb mt0"
                            >
                                <span className="fw400">10 mm</span>
                                <span className="float-right">
                                    {(drawerData?.reinforcement[0]?.type !== 10) ? (drawerData?.reinforcement[1]?.type === 10) ?  (drawerData?.reinforcement[1]?.count) : 
                                     0 : (drawerData?.reinforcement[0]?.count)}
                                </span>
                            </Text>
                        </Grid>
                         {/* ----------12mm----------- */}
                         <Grid item xs={12}>
                            <Text
                                type="normal"
                                fonts="normal"
                                fontSize={14}
                                className="mb mt0"
                            >
                                <span className="fw400">12 mm</span>
                                <span className="float-right">
                                    {(drawerData?.reinforcement[0]?.type !== 12) ? (drawerData?.reinforcement[1]?.type !== 12) ? (drawerData?.reinforcement[2]?.type === 12) ?(drawerData?.reinforcement[2]?.count) : "0" 
                                 : (drawerData?.reinforcement[1]?.count) : (drawerData?.reinforcement[0]?.count)}
                                </span>
                            </Text>
                        </Grid>
                        {/* ----------16mm----------- */}
                        <Grid item xs={12}>
                            <Text
                                type="normal"
                                fonts="normal"
                                fontSize={14}
                                className="mb mt0"
                            >
                                <span className="fw400">16 mm</span>
                                <span className="float-right">
                                {(drawerData?.reinforcement[0]?.type !== 16) ? (drawerData?.reinforcement[1]?.type !== 16) ? (drawerData?.reinforcement[2]?.type !== 16) ? (drawerData?.reinforcement[3]?.type === 16) ? (drawerData?.reinforcement[3]?.count) : "0" 
                   : (drawerData?.reinforcement[2]?.count) : (drawerData?.reinforcement[1]?.count) : (drawerData?.reinforcement[0]?.count)}
                                </span>
                            </Text>
                        </Grid>
                        {/* ----------20mm----------- */}
                        <Grid item xs={12}>
                            <Text
                                type="normal"
                                fonts="normal"
                                fontSize={14}
                                className="mb mt0"
                            >
                                <span className="fw400">20 mm</span>
                                <span className="float-right">
                                {(drawerData?.reinforcement[0]?.type !== 20) ? (drawerData?.reinforcement[1]?.type !== 20) ? (drawerData?.reinforcement[2]?.type !== 20) ? (drawerData?.reinforcement[3]?.type !== 20) ? (drawerData?.reinforcement[4]?.type === 20) 
                   ? (drawerData?.reinforcement[4]?.count) : "0" : (drawerData?.reinforcement[3]?.count)
                   : (drawerData?.reinforcement[2]?.count) : (drawerData?.reinforcement[1]?.count) : (drawerData?.reinforcement[0]?.count)}
                                </span>
                            </Text>
                        </Grid>
                        {/* ----------25mm----------- */}
                        <Grid item xs={12}>
                            <Text
                                type="normal"
                                fonts="normal"
                                fontSize={14}
                                className="mb mt0"
                            >
                                <span className="fw400">25 mm</span>
                                <span className="float-right">
                                {(drawerData?.reinforcement[0]?.type !== 25) ? (drawerData?.reinforcement[1]?.type !== 25) ? (drawerData?.reinforcement[2]?.type !== 25) ? (drawerData?.reinforcement[3]?.type !== 25) ? (drawerData?.reinforcement[4]?.type !== 25) ?
                   (drawerData?.reinforcement[5]?.type === 25)  ? (drawerData?.reinforcement[5]?.count) : "0" : (drawerData?.reinforcement[4]?.count) : (drawerData?.reinforcement[3]?.count)
                  : (drawerData?.reinforcement[2]?.count) : (drawerData?.reinforcement[1]?.count) : (drawerData?.reinforcement[0]?.count)}
                                </span>
                            </Text>
                        </Grid>
                        {/* ----------32mm----------- */}
                        <Grid item xs={12}>
                            <Text
                                type="normal"
                                fonts="normal"
                                fontSize={14}
                                className="mb mt0"
                            >
                                <span className="fw400">32 mm</span>
                                <span className="float-right">
                                {(drawerData?.reinforcement[0]?.type !== 32) ? (drawerData?.reinforcement[1]?.type !== 32) ? (drawerData?.reinforcement[2]?.type !== 32) ? (drawerData?.reinforcement[3]?.type !== 32) ? (drawerData?.reinforcement[4]?.type !== 32) ?
                 (drawerData?.reinforcement[5]?.type !== 32)  ? (drawerData?.reinforcement[6]?.type === 32) ? (drawerData?.reinforcement[6]?.count) : "0" : (drawerData?.reinforcement[5]?.count) : (drawerData?.reinforcement[4]?.count) : (drawerData?.reinforcement[3]?.count)
                 : (drawerData?.reinforcement[2]?.count) : (drawerData?.reinforcement[1]?.count) : (drawerData?.reinforcement[0]?.count)}
                                </span>
                            </Text>
                        </Grid>
                        {/* ----------36mm----------- */}
                        <Grid item xs={12}>
                            <Text
                                type="normal"
                                fonts="normal"
                                fontSize={14}
                                className="mb mt0"
                            >
                                <span className="fw400">36 mm</span>
                                <span className="float-right">
                                { (drawerData?.reinforcement[0]?.type !== 36) ? (drawerData?.reinforcement[1]?.type !== 36) ? (drawerData?.reinforcement[2]?.type !== 36) ? (drawerData?.reinforcement[3]?.type !== 36) ? (drawerData?.reinforcement[4]?.type !== 36) ?
                 (drawerData?.reinforcement[5]?.type !== 36)  ? (drawerData?.reinforcement[6]?.type !== 36) ? (drawerData?.reinforcement[7]?.type === 36) ? (drawerData?.reinforcement[7]?.count) : "0" : (drawerData?.reinforcement[6]?.count)
                 : (drawerData?.reinforcement[5]?.count) : (drawerData?.reinforcement[4]?.count) : (drawerData?.reinforcement[3]?.count)
                 : (drawerData?.reinforcement[2]?.count) : (drawerData?.reinforcement[1]?.count) : (drawerData?.reinforcement[0]?.count)}
                                </span>
                            </Text>
                        </Grid>
                        {/* ----------Total Consumed----------- */}
                        <Grid item xs={12}>
                            <Text
                                type="normal"
                                fonts="normal"
                                fontSize={14}
                                className="mb mt0"
                            >
                                <span className="fw400">Total Consumed (m)</span>
                                <span className="float-right">
                                    {drawerData?.total}
                                </span>
                            </Text>
                        </Grid>
                    </Grid>

                </Grid>
            </div>
        </Grid>
    );
};

export default PileDrawer;